import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import React, { useEffect, useRef, useState } from "react";
import { useSelections } from "../../context/Selections";

function InvestmentsMobile({ app, config }) {
  const { cards } = config.investments;
  const { title } = cards[0];
  const [id, setId] = useState("928416ae-6447-460d-9163-52ddf2309b99");
  const { selections } = useSelections();

  useEffect(() => {
    if (selections.length) {
      const selection =
        selections.find((selection) => selection.qField === "Ano")
          ?.qSelected === "FY23" ?? false;
      setId(
        selection
          ? "e41b8db2-deb9-4c41-9a12-7bd7e160d5cc"
          : "928416ae-6447-460d-9163-52ddf2309b99"
      );
    }
  }, [selections]);

  return (
    <div className="app investments">
      <div className="appContent">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Card
            exportTable
            app={app}
            exportTableId="LhRRa"
            header={{
              hardTitle: title.hardTitle,
              tooltip: title.tooltip,
            }}
            style={{ width: "100%", height: "500px", alignItems: "center" }}
          >
            <NativeObject
              app={app}
              key="LhRRa"
              reference={{ id: "LhRRa" }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

InvestmentsMobile.defaultProps = {
  app: null,
  config: {},
};

InvestmentsMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InvestmentsMobile;
